var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0;}.b{fill:red;}.c{fill:#707070;}.d{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb5cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b36fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-291 -1594.895)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 60,
    height: 60,
    transform: "translate(291 1594.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1,1V59H59V1H1M0,0H60V60H0Z",
    transform: "translate(291 1594.895)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,3.016A3.022,3.022,0,0,1,3.026-.01H9.077A3.022,3.022,0,0,1,12.1,3.016V9.067H0Zm0,9.077H12.1V36.3H0ZM0,39.324H12.1v6.051A3.022,3.022,0,0,1,9.077,48.4H3.026A3.022,3.022,0,0,1,0,45.376ZM15.129,3.016A3.022,3.022,0,0,1,18.154-.01h6.051a3.022,3.022,0,0,1,3.026,3.026V9.067h-12.1Zm0,9.077h12.1V36.3h-12.1Zm0,27.231h12.1v6.051A3.022,3.022,0,0,1,24.206,48.4H18.154a3.022,3.022,0,0,1-3.026-3.026ZM34.38,37.443,30.257,21.983V13.492l9.493-2.543,6.241,23.392Zm4.6-29.416-8.718,2.326V1.03L33.746.094a3,3,0,0,1,3.678,2.137Zm-3.82,32.337,11.611-3.111,1.541,5.777a3.024,3.024,0,0,1-2.127,3.7l-5.806,1.56A3,3,0,0,1,36.7,46.151Z",
    transform: "translate(297 1600.699)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBooks);
export default __webpack_public_path__ + "static/media/iconBooks.7ffc5053e30200e155e3f57d024226d9.svg";
export { ForwardRef as ReactComponent };